import {jwtDecode} from 'jwt-decode';

export function getCurrentUserId() {
    const token = localStorage.getItem('token');
    if (!token) return null;
    try {
        const decoded = jwtDecode(token);
        return decoded['user_id'] || null;
    } catch (e) {
        return null;
    }
}

export function getToken() {
    return localStorage.getItem('token');
}

export function getCurrentUserRole() {
    const token = getToken();
    if (!token) return null;
    try {
        const decoded = jwtDecode(token);
        return decoded['role'] || null;
    } catch (e) {
        return null;
    }
}

export function getCurrentUserOrgId() {
    const token = getToken();
    if (!token) return null;
    try {
        const decoded = jwtDecode(token);
        return decoded['organisation_id'] || null;
    } catch (e) {
        return null;
    }
}

export function parseJwt(token) {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
}
